import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { isStr } from 'ionicons/dist/types/icon/utils';
import { isString } from 'util';

@Component({
  selector: 'app-printquiz',
  templateUrl: './printquiz.component.html',
  styleUrls: ['./printquiz.component.scss'],
})
export class PrintquizComponent implements OnInit {

  @Input() url: any;
  //@Output() eventchild = new EventEmitter<string>();

  tabQuest = [];

  total: number = 0;
  nbquest: number = 0;

  constructor() { }

  ngOnInit() { }//test()}

  ngOnChanges() {
    //test() { 

    //alert(JSON.stringify(this.url));
    //this.url = JSON.parse('[[{"text":"Afin de vérifier vos acquis,répondez aux questions suivantes :" , "tot" : 1 ,  "nbq" : 5}],[{"text":"Avec le langage Python vous pouvez (plusieurs réponses sont possibles) :"},{"chekbox":[{"label":"Piloter une voiture autonome","sol":true,"res":false},{"label":"Faire de la reconnaissance faciale","sol":true,"rep":true},{"label":"Laver la vaisselle à la main","rep":true},{"label":"Faire des calculs scientifiques","sol":true}]}],[{"text":"Quels ont été les premiers programmeurs?"},{"radio":[{"label":"Des femmes","sol":true,"rep":true,"res":true},{"label":"Des hommes","rep":false}]}],[{"text":"Comment s\'appelle le premier langage de programmation compilé à avoir été créé?"},{"radio":[{"label":"Fortran","sol":true,"rep":false,"res":false},{"label":"Python","rep":false},{"label":"C","rep":false},{"label":"JavaScript","rep":true}]}],[{"text":"Par qui à été créé le langage Python?"},{"radio":[{"label":"Guido van Rossum","sol":true,"rep":false,"res":false},{"label":"Steeve Job","rep":false},{"label":"Bill Gates","rep":true},{"label":"Dennis Ritchie","rep":false}]}],[{"text":"En quelle année a été créé le langage Python?"},{"radio":[{"label":"1989","sol":true,"rep":false,"res":false},{"label":"1849","rep":false},{"label":"2009","rep":true},{"label":"1789","rep":false}]}]]');

    if (!isString(this.url)) {
      this.tabQuest = this.url;

      let lgTab = Object.keys(this.url).length;
      //let lgTab = this.tabQuest[this.posiquest].length;
      //alert(lgTab);
      //let tab1 : any; 
      //alert(JSON.stringify(tabPage));
      this.total = this.url[0][0]["tot"];
      this.nbquest = this.url[0][0]["nbq"];


      for (let i = 1; i < lgTab; i++) {
        let lgTab1 = Object.keys(this.url[i]).length;
        for (let j = 0; j < lgTab1; j++) {
          for (let x in this.url[i][j]) {
            this.tabQuest.push({
              //  id: i,
              key: x,
              value: this.url[i][j][x]
            });
          }
        }
      }//fin for
    }//fin if


  }

  retourchild($event) {
    //alert($event);
    //if ($event == "btvalider") this.visibtvalider = true;

  }



}
